<template>
  <div class="loadingBox">
    <img src="https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=preloding.png" />
  </div>
</template>
<script>
import util from "@/util/util";
import home from "@/api/home";
import request from "@/util/request";
export default {
  name: "loading",
  data(){
    return{
      bindKdy:''
    }
  },
  created() {
    this.$store.commit("SET_ROUTE_FROM", "/loading");
    if (this.getQueryVariable("code")) {
      this.toLogin();
    } else {
      this.connectwebsockt();
      this.login_homeBus();
      setTimeout(() => {
        this.$router.push({ path: "/home" });
      }, 500);
    }
  },
  methods: {
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    toLogin() {
      const code = this.getQueryVariable("code");
      home.login(code).then((res) => {
        if (res.success) {
          const data = res.data;
          util.setCookie("account_id", data.data.account_id);
          util.setCookie("token", data.token);
          util.setCookie("websocket_token", data.data.websocket_token);
          util.setCookie("app_key", data.data.app_key);
          util.setCookie("nickname", data.data.nickname);
          util.setCookie("headimgurl", data.data.headimgurl);
          this.connectwebsockt();
          this.login_homeBus();
        } else {
          util.removeCookie("account_id");
          util.removeCookie("token");
          util.removeCookie("websocket_token");
          util.removeCookie("app_key");
          util.removeCookie("nickname");
          util.removeCookie("headimgurl");
        }
      });
    },
    login_homeBus(){
      const treenum = {
        print_type:1,
        start_time:util.getlimiTime(2) + ' 00:00:00',
        end_time:util.getlimiTime(0)+' 23:59:59',
      }
      request.post(this,{
        action:'kdyserver.account.homeBus',
        data:{
          'parameters':request.getBusparameters([
            {action:'kdyserver.account.commondict',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.account.banners',data:{type:1,account_id: util.getCookie("account_id")}},
            {action:'kdyserver.account.hasbind',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.team.model.select',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.order.logistics.orderstatic',data:{}},
            {action:'kdyserver.order.printOrderStatics',data:treenum},
            {action:'kdyserver.message.getIsRead',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.message.getNewNotReadMessage',data:{account_id: util.getCookie("account_id")}},  //获取最新未读消息
          ])
        }
      }).then(res=>{
        if(res.success){
           const datas = res.body.data; 
           this.$store.commit("SET_COMMON_DICT", JSON.stringify(datas[0]));
           this.$store.commit("SET_BANNER_LIST", datas[1].data);
           this.bindKdy = datas[2].data
           this.$store.commit("SET_BIND_KDY", datas[2].data);
           util.setCookie("teamModel", datas[3].data);
           this.$store.commit('SET_TEAM_MODEL', datas[3].data)
           this.$store.commit("SET_PRINT_NUM", datas[4].data.yes_print_num);
           this.$store.commit("SET_ORDER_NUM", datas[4].data.yes_print_num);
           this.$store.commit("SET_WAIT_NUM", datas[5].data);
           this.$store.commit("SET_MAIL_NUM", datas[6].code== 200 ? 0 : 1);
           setTimeout(() => {
              if (this.bindKdy == 0) {
              this.$alert('您的绑定关系正在审核中，暂时无法正常使用打印功能,请联系对口快递员审核绑定关系。', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {
                  this.showNewinfo(datas[7])    
                }});
              } else if (this.bindKdy == 99 ||this.bindKdy == 4) {
              this.$alert('您还未添加电子面单账号，无法正常使用下单功能，请添加网点电子面单账号或绑定协议快递员。', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {
                  this.showNewinfo(datas[7]) 
                }});
              } else {
                  this.showNewinfo(datas[7]) 
              }
              this.$router.push({ path: "/home" });
           }, 500);
        }
      })
    },
    //展示最新提示
    showNewinfo(obj){
      if(obj.code != 200){
        return 
      } 
      this.$toast(true,obj.data,'newtipInfo',()=>{
        // next()
      })
    },

    // hasbind(){
    //   //判断是否绑定快递员
    //   home.hasbind(this).then((res) => {
    //     this.bindKdy = res.data
    //     this.$store.commit("SET_BIND_KDY", res.data);
    //   });
    // },
    // getcommondata() {
    //   home.commondict(this).then((res) => {
    //     if (res.success) {
    //       this.$store.commit("SET_COMMON_DICT", JSON.stringify(res.data));
    //     }
    //   });
    // },
    // getBanner() {
    //   question.bannerList(this).then((res) => {
    //     if (res.success) {
    //       this.$store.commit("SET_BANNER_LIST", res.data);
    //     }
    //   });
    // },
    connectwebsockt() {
      if (util.jgEnv()=='pro') {
        // 生产环境
        this.$WebSocketClass.connect(
          "wss://ysb.yundasys.com/ws/subscribe?wsToken=" +
            util.getCookie("websocket_token") +
            "&appKey=" +
            util.getCookie("app_key")
        );
      } else {
        // 测试环境
        this.$WebSocketClass.connect(
          "wss://u-openapi.yundasys.com/ws/subscribe?wsToken=" +
            util.getCookie("websocket_token") +
            "&appKey=" +
            util.getCookie("app_key")
        );
      }
    },
    // getRealName(){
    //   bindKdy.checkRealName(this).then(res=>{
    //     if(res.success){
    //        this.$store.commit("SET_YD_REALNAME", res.data);
    //     }
    //   })
    // }
  },
};
</script>
<style lang="stylus" scoped>
.loadingBox{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    img{
        width: 300px;
        height: 320px;
    }
}
</style>
